module.exports = __webpack_public_path__ + "img/202412_flora_03.4891922f.jpg";